import { Box, Heading, Link, Text } from '@betterment/samba-react';

const ErrorMessage = () => {
  return (
    <Box css={{ display: 'grid', gap: 'space.100', textAlign: 'center' }}>
      <Heading variant="title300">Unable to complete request</Heading>
      <Text>
        We're sorry, we're working to resolve this issue. Please try again later. If the issue continues, contact us for
        help at <Link href="mailto:support@betterment.com">support@betterment.com</Link>
      </Text>
    </Box>
  );
};

export default ErrorMessage;
